import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function WorkDetail() {
  const { id } = useParams();
  const [work, setWork] = useState(null);

  useEffect(() => {
    const fetchWork = async () => {
      try {
        const res = await fetch(`/api/work/${id}`);
        if (!res.ok) throw new Error('Fetch failed');
        const data = await res.json();
        setWork(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchWork();
  }, [id]);

  if (!work) return <div className="work-detail"><p>Loading...</p></div>;

  return (
    <div className="work-detail">
      <section className="page-intro">
        <h1>{work.title}</h1>
        <p>{work.service}</p>
      </section>
      <section className="work-content">
        {work.image && <img src={work.image} alt={work.title} />}
        <div className="work-desc">
          <p>{work.description}</p>
          {work.url && <p><a href={work.url} target="_blank" rel="noreferrer">View live project</a></p>}
        </div>
      </section>
    </div>
  );
}

export default WorkDetail;
